module.exports = __webpack_public_path__ + "static/gal-3019bbf712c66247b000ab61cb245a4e.jpg";